//import region
import React, {useEffect, useState} from 'react';


// custom components
import CircleDigit from './circle-digit';
import { calculatePercentageAccuracy, calculateAPE } from '_components/organisms/utils/prm-booking';
import { Colors } from '_styles';
//end  import region
  
const PercentageDifferenceRow = (props) => {   
    // states 
    const [outboundDifference, setOutboundDifference] = useState(0);
    const [inboundDifference, setInboundDifference] = useState(0);
    const [totalDifference, setTotalDifference] = useState(0);

    //useeffect region
    useEffect(() => {

        
        if(props.outboundCount && props.outboundForecastCount){
            let outboundTemp = calculatePercentageAccuracy(props.outboundCount, props.outboundForecastCount)
            if(outboundTemp){
                setOutboundDifference(Math.round(outboundTemp))
            }
        }
        if(props.inboundCount && props.inboundForecastCount){
            let inboundTemp = calculatePercentageAccuracy(props.inboundCount, props.inboundForecastCount);
            if(inboundTemp){
                setInboundDifference(Math.round(inboundTemp))
            }
        }
       
      if(props.isPastDate){
            // get sum of actuals and sum of forecast
            let forecastTotal = props.outboundForecastCount + props.inboundForecastCount;
            let actualTotal = props.outboundCount + props.inboundCount;
            let temp = calculatePercentageAccuracy(actualTotal, forecastTotal);
          
            //console.log(props.date + ' inbound: ' + props.inboundCount + ' outbound: ' + props.outboundCount + ' inboundForecast: ' + props.inboundForecastCount + ' outboundForecast: ' + props.outboundForecastCount + ' total: ' + temp)
            
            if(temp){
                setTotalDifference(Math.round(temp));
            }       
            else {
                setTotalDifference('');
            }
      }
    }, [props]);
    // end region

    return (
        <div style={{
            display:'flex', // borderStyle:'solid', borderWidth:1
        }}>
            { props.isPastDate &&
            <div style={{ display:'flex'}}>
                <CircleDigit
                    number={''}
                    textColor={'white'}
                    //textColor={Colors.PRM_LIGHT_BLUE}
                    //number={props.outboundLoading ? '' : outboundDifference + '%'}
                />
                <CircleDigit
                    number={''}
                    textColor={'white'}
                    //textColor={'green'}
                    //number={props.inboundLoading ? '' : inboundDifference + '%'}
                    margin={true}
                />
                <CircleDigit
                    number={props.inboundLoading || props.outboundLoading ? '' : totalDifference + '%'}
                    textColor={'gray'}
                    margin={true}
                />
            </div>
            }
        </div>
    );
};

export default PercentageDifferenceRow;
